import type { FieldErrors } from '../api/errors';
import { selectCustomFields, selectHeading } from '../state/selectors';
import { useFormState } from './context';
import { CustomFields } from './CustomFields';
import { FrequencyPicker } from './FrequencyPicker';
import { Section } from './Section';
import { ServicePicker } from './ServicePicker';

interface Props {
  errors: FieldErrors;
}

/** Step 2 — the vehicle: package, extras, frequency, and the tenant's custom fields. */
export function Step2({ errors }: Props) {
  const state = useFormState();
  const { main } = selectCustomFields(state);
  return (
    <>
      <ServicePicker errors={errors} />
      <FrequencyPicker errors={errors} />
      {main.length ? (
        <Section heading={selectHeading(state, 'custom_fields_section')}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <CustomFields fields={main} errors={errors} />
          </div>
        </Section>
      ) : null}
    </>
  );
}
